module.exports = __webpack_public_path__ + "static/img/huko-logo.21a1633.svg";